/* eslint-disable no-unused-vars */
// FilterDivisionOneSelect.js
import React from "react";
import { PatchedSelect } from "./selectDropdownPatch";
import "./selectDropdownPatch.css";

export default function FilterDivisionOneSelect({
  data,
  filters,
  userData,
  handleEvents }) {
  const countries =
    Array.isArray(filters.country) && filters.country.length > 0
      ? filters.country
      : Object.keys((data && data.departments) || {});

  const departments = [];
  (countries || []).forEach((cc) => {
    const list = (data.departments && data.departments[cc]) || [];
    list.forEach((d) => departments.push(d));
  });

  // ✅ department ที่เลือก
  const departmentsSelected = Array.isArray(filters.department)
    ? filters.department.map(String)
    : [];

  const divisionsMap = data.divisions || {};
  const choices = [];

  // ✅ ใช้เฉพาะ department ที่เลือกไว้เท่านั้น
  departments
    .filter((dept) => departmentsSelected.includes(String(dept.dept_id)))
    .slice()
    .sort((a, b) => (a.dept_name || "").localeCompare(b.dept_name || ""))
    .forEach((dept) => {
      const labelDept = dept.dept_name || String(dept.dept_id);
      const divs = (divisionsMap[dept.dept_id] || [])
        .slice()
        .sort((a, b) => (a.dept_name || "").localeCompare(b.dept_name || ""));

      if (divs.length === 0) return;

      // ✅ department label
      choices.push({
        type: "label",
        key: `L:${dept.dept_id}`,
        text: labelDept,
        className: `option-label dept-${dept.dept_id}` });

      // ✅ divisions จริง
      divs.forEach((div) => {
        choices.push({
          type: "option",
          key: `V:${div.dept_id}`,
          value: String(div.dept_id),
          text: div.dept_name || String(div.dept_id) });
      });
    });

  // ✅ เฉพาะ option ที่ยังอยู่ใน choices
  const visibleOptionIds = new Set(
    choices.filter((c) => c.type === "option").map((c) => c.value)
  );

  let selected = Array.isArray(filters.division)
    ? filters.division.map(String)
    : [];

  let valueForSelect = selected.filter((id) => visibleOptionIds.has(id));

  const onChangeDivisions = (e) => {
    const values = Array.from(e.target.selectedOptions, (o) => o.value);
    handleEvents.OnChange({
      target: { name: "division", value: values, type: "select-multiple" } });
  };

  const disabled = choices.length === 0;
  const selectId = "filter-inp-division";

  return (
    <div className="filter-input-field select" key="filter-division-one-select">
      <PatchedSelect
        multiple
        id={selectId}
        className={"patched-selected"}
        name="division"
        value={valueForSelect}
        onChange={onChangeDivisions}
        patchOptions={{
          labelClass: "option-label",
          clearActive: true }}
        options={{
          dropdownOptions: {
            alignment: "left",
            autoTrigger: true,
            closeOnClick: false,
            constrainWidth: true,
            coverTrigger: true,
            hover: false,
            inDuration: 150,
            outDuration: 250 } }}
      >
        {/* ✅ placeholder option */}
        <option value="" disabled className="option-placeholder">
          Division
        </option>

        {choices.map((ch) =>
          ch.type === "label" ? (
            <option key={ch.key} value={ch.key} disabled>
              {ch.text}
            </option>
          ) : (
            <option key={ch.key} value={ch.value}>
              {ch.text}
            </option>
          )
        )}
      </PatchedSelect>

      {/* <span
        className="select-helper-text helper-text"
        id="helper-text-division"
      >
        {disabled
          ? "No Division available for the selected country/department"
          : "You can select multiple Divisions (hold Ctrl/Cmd to multi-select)"}
      </span> */}
    </div>
  );
}

